export default "__VITE_ASSET__DtPyg6uY__"